// アバター fallback（画像なし）の背景色は gender 別ルールに統一する。
// 男性=青 / 女性=ピンク / 不明・該当なし=オレンジ（PersonAvatar と同じトークン）。
// 管理者は gender 非依存の緑（呼び出し側で --admin-avatar-fallback-bg を使う）。
// ※ 以前あった名前ハッシュ7色（colorFromString / CHAT_AVATAR_PALETTE）は廃止した。
export const artistGenderAvatarBg = (gender = '') => {
  const g = String(gender || '').trim().toLowerCase();
  if (g === 'male' || g === 'man' || g === 'm' || g === '男性' || g === '男') {
    return 'var(--person-avatar-artist-male-bg)';
  }
  if (g === 'female' || g === 'woman' || g === 'f' || g === '女性' || g === '女') {
    return 'var(--person-avatar-artist-female-bg)';
  }
  return 'var(--person-avatar-artist-unknown-bg)';
};
